import { UnitDetailSpokeContent } from './UnitDetailSpokeContent';
import type { Floorplan, Unit } from '../UnitTable';

type UnitDetailPanelProps = {
  config?: unknown;
};

export const UnitDetailPanel = ({ config }: UnitDetailPanelProps) => {
  const { unit, floorplan } = config as { unit: Unit; floorplan: Floorplan };

  return <UnitDetailSpokeContent unit={unit} floorplan={floorplan} />;
};
